<div class="modal-dialog modal-xl mt-0 mb-0" role="document">
  <div class="modal-content" style="min-height: 450px;">
    
    <div class="modal-body pb-0 no-print">
      <button type="button" (click)="bsModalRef.hide()" class="btn-close btn-danger float-end"></button>
      
      <div class="col-lg-12 col-md-12 col-sm-12 mb-1">
        <h4 class="titulo_seccao">Visualização de Relatório Ofical</h4>
      </div>
    </div>
    <div class="modal-body pt-2" id="print-section">
      
      <div class="report-paper">   
        <button type="button" class="btn btn-primary px-2 no-print float-end" (click)="imprimir()" style="margin-top:-10px">
          <i class="fa fa-print me-2"></i> IMPRIMIR </button>               
        <div class="text-center mb-0">
          <h5 class="fw-bold mb-2">RELATÓRIO LAUDO PMG</h5>
        </div>

        <div *ngIf="dadosLaudo">
          
        <table class="table table-sm table-bordered border-dark mb-3 small laudo-pmmg">
          <tbody>
             <tr>
              <td colspan="3" class="py-1">
                <h6 class="fw-bold mb-0 text-center">FORMULÁRIO PARA CLASSIFICAÇÃO DE DANOS EM VEÍCULOS SINISTRADOS</h6>
              </td>
             </tr>
            <tr>
              <!-- Célula da Logo ocupando as 4 linhas -->
              <td rowspan="4" class="text-center align-middle" style="width: 120px;">
                <img src="assets/SigaParts_01.png" alt="Logo PMMG" class="img-fluid" style="max-height: 80px;">
              </td>
              
              <td><strong>Veículo:</strong> {{ dadosLaudo?.laudo_tipo }}</td>
              <td><strong>Protocolo:</strong> {{ protocolo }}</td>
            </tr>
            <tr>
              <td><strong>Placa:</strong> {{ dadosLaudo?.placa }}</td>
              <td><strong>Nº BAT:</strong> {{ dadosLaudo?.laudo_numero_bat }}</td>
            </tr>
            <tr>
              <td><strong>Nome do Perito/Agente:</strong> {{ dadosLaudo?.agente }}</td>
              <td><strong>Nº BO:</strong> {{ dadosLaudo?.bo }}</td>
            </tr>
            <tr>
              <td><strong>Registro/Matrícula do Agente:</strong> {{ dadosLaudo?.numero_registro }}</td>
              <td><strong>Data:</strong> {{ dataGeracao | date:'dd/MM/yyyy' }}</td>
            </tr>
          </tbody>
        </table>

          <div class="text-center border border-dark border-bottom-0 py-1 bg-white" style="font-size: 10pt;">     
            
             <!-- AUTOMOVEL -->
            <p class="fw-bold text-uppercase m-0" *ngIf="dadosLaudo?.laudo_tipo == 'Automóvel'">
            AUTOMÓVEIS, CAMIONETAS, CAMINHONETES E UTILITÁRIOS, COM ESTRUTURA EM MONOBLOCO
            </p>
            <!-- MOTOCICLETAS -->
            <p class="fw-bold text-uppercase m-0" *ngIf="dadosLaudo?.laudo_tipo == 'Motocicleta'">
            MOTOCICLETAS, MOTONETAS, CICLOMOTORES, TRICICLOS E QUADRICICLOS
            </p>            
            <!-- Caminhão / Cavalo Mecânico -->
            <p class="fw-bold text-uppercase m-0" *ngIf="dadosLaudo?.laudo_tipo == 'Caminhão' || dadosLaudo?.laudo_tipo == 'Cavalo Mecânico'">
            REBOQUES, SEMIRREBOQUES, CAMINHÕES, CAMINHÕES TRATORES, ALÉM DE CAMIONETAS, CAMINHONETES E UTILITÁRIOS, COM ESTRUTURA EM CHASSI
            </p>  
            <!-- ÔNIBUS E MICRO-ÔNIBUS -->          
            <p class="fw-bold text-uppercase m-0" *ngIf="dadosLaudo?.laudo_tipo == 'Ônibus'">
            ÔNIBUS E MICRO-ÔNIBUS
            </p>

            <p class="text-uppercase m-0">
            COMPONENTES, PEÇAS ESTRUTURAIS/SEGURANÇA PASSIVA AVARIADAS NO ACIDENTE
            </p>
          </div>

        <div class="d-flex align-items-start gap-3 w-100">
  
          <!-- ======================================================================= -->
          <!-- LAYOUT 1: COLUNA ÚNICA (Apenas para Caminhão e Cavalo Mecânico)        -->
          <!-- ======================================================================= -->
          <ng-container *ngIf="dadosLaudo?.laudo_tipo === 'Caminhão' || dadosLaudo?.laudo_tipo === 'Ônibus'">
            <table class="table table-sm table-bordered border-dark mb-0 table-report laudo-pmmg tabela-impressao">
              <thead>
                <tr class="text-center small">
                  <th rowspan="2" class="align-middle">Item</th>
                  <th rowspan="2" class="align-middle text-start px-2">Nome da peça</th>
                  <th rowspan="2" class="align-middle">Valor</th>
                  <th colspan="3" class="py-0">Avaliação</th>
                </tr>
                <tr class="text-center small">
                  <th class="py-0">SIM</th>
                  <th class="py-0">NÃO</th>
                  <th class="py-0">N/A</th>
                </tr>
              </thead>
              <tbody class="small">
                <!-- Aqui usamos a lista original COMPLETA direta, um embaixo do outro -->
                <tr *ngFor="let item of listaParaExibir">
                  <td class="text-center align-middle fw-bold">{{ item.numero }}</td>
                  <td class="align-middle px-2">{{ item.descricao }}</td>
                  <td class="text-center align-middle fw-bold">{{ item.valor || '-' }}</td>
                  <td class="text-center align-middle fw-bold" [class.bg-mark]="item.resposta === 'SIM'">{{ item.resposta === 'SIM' ? 'X' : '' }}</td>
                  <td class="text-center align-middle fw-bold" [class.bg-mark]="item.resposta === 'NÃO'">{{ item.resposta === 'NÃO' ? 'X' : '' }}</td>
                  <td class="text-center align-middle fw-bold" [class.bg-mark]="item.resposta === 'NA' || item.resposta === 'N/A'">{{ (item.resposta === 'NA' || item.resposta === 'N/A') ? 'X' : '' }}</td>
                </tr>
                <tr>  
                  <td colspan="3" class="text-end px-1 fw-bold">TOTAL GERAL (SIM+N/A)</td>
                  <td colspan="3" class="text-center fw-bold">{{ totalGeral }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>

          <!-- ======================================================================= -->
          <!-- LAYOUT 2: DUAS COLUNAS LADO A LADO (Para Automóvel, Moto, etc.)       -->
          <!-- ======================================================================= -->
          <ng-container *ngIf="dadosLaudo?.laudo_tipo === 'Automóvel' || dadosLaudo?.laudo_tipo === 'Motocicleta'">
            <table class="table table-sm table-bordered border-dark mb-0 table-report laudo-pmmg tabela-impressao">
              <thead>
                <tr class="text-center small">
                  <!-- Bloco da Esquerda (Total: 50%) -->
                  <th rowspan="2" class="align-middle">Item</th>
                  <th rowspan="2" class="align-middle text-start px-2">Nome da peça</th>
                  <th colspan="3" class="py-0">Avaliação</th>
                  <!-- Bloco da Direita (Total: 50%) -->
                  <th rowspan="2" class="align-middle">Item</th>
                  <th rowspan="2" class="align-middle text-start px-2">Nome da peça</th>
                  <th colspan="3" class="py-0">Avaliação</th>
                </tr>
                <tr class="text-center small">
                  <th class="py-0">SIM</th>
                  <th class="py-0">NÃO</th>
                  <th class="py-0">N/A</th>
                  <th class="py-0">SIM</th>
                  <th class="py-0">NÃO</th>
                  <th class="py-0">N/A</th>
                </tr>
              </thead>
              <tbody class="small">
                <tr *ngFor="let itemEsq of listaColuna1; let i = index">
                  <!-- DADOS DA ESQUERDA -->
                  <td class="text-center align-middle fw-bold">{{ itemEsq.numero }}</td>
                  <td class="align-middle px-2">{{ itemEsq.descricao }}</td>
                  <td class="text-center align-middle fw-bold" [class.bg-mark]="itemEsq.resposta === 'SIM'">{{ itemEsq.resposta === 'SIM' ? 'X' : '' }}</td>
                  <td class="text-center align-middle fw-bold" [class.bg-mark]="itemEsq.resposta === 'NÃO'">{{ itemEsq.resposta === 'NÃO' ? 'X' : '' }}</td>
                  <td class="text-center align-middle fw-bold" [class.bg-mark]="itemEsq.resposta === 'NA' || itemEsq.resposta === 'N/A'">{{ (itemEsq.resposta === 'NA' || itemEsq.resposta === 'N/A') ? 'X' : '' }}</td>
                  <!-- DADOS DA DIREITA -->
                  <td class="text-center align-middle fw-bold">{{ listaColuna2[i]?.numero || '' }}</td>
                  <td class="align-middle px-2">{{ listaColuna2[i]?.descricao || '' }}</td>
                  <td class="text-center align-middle fw-bold" [class.bg-mark]="listaColuna2[i]?.resposta === 'SIM'">{{ listaColuna2[i]?.resposta === 'SIM' ? 'X' : '' }}</td>
                  <td class="text-center align-middle fw-bold" [class.bg-mark]="listaColuna2[i]?.resposta === 'NÃO'">{{ listaColuna2[i]?.resposta === 'NÃO' ? 'X' : '' }}</td>
                  <td class="text-center align-middle fw-bold" [class.bg-mark]="listaColuna2[i]?.resposta === 'NA' || listaColuna2[i]?.resposta === 'N/A'">{{ (listaColuna2[i]?.resposta === 'NA' || listaColuna2[i]?.resposta === 'N/A') ? 'X' : '' }}</td>
                </tr>
                <tr>
                  <td colspan="6"></td>
                  <td class="text-end px-1 fw-bold">TOTAL GERAL (SIM+N/A)</td>
                  <td colspan="3" class="text-center fw-bold">{{ totalGeral }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>



      </div>


          <div class="border border-dark border-top-0 p-1">
            <small class="fw-bold d-block">Observações:</small>
            <div class="small min-height-obs">
              {{ dadosLaudo?.observacao || 'Nenhuma.' }}
            </div>
          </div>
 
        <div class="border border-dark border-top-0 p-1 mb-3" style="font-size: 11pt;">
          <div class="small lh-base text-dark">
            <span class="fw-bold">SIM</span> = item danificado no acidente.<br>
            <span class="fw-bold">NÃO</span> = item não danificado ou não existente.<br>
            <span class="fw-bold">N/A</span> = item que não foi possível avaliar o dano (Não Avaliado), deve ser justificado.
          </div>
        </div>

          <div class="border border-dark p-2">
            <div class="row align-items-center">
              <div class="col-9 small">
                <p class="mb-1"><strong>AVALIAÇÃO DO DANO:</strong></p>
                
                <!-- Automóvel -->
                <ul *ngIf="dadosLaudo?.laudo_tipo == 'Automóvel'" 
                    class="list-unstyled mb-0" style="font-size: 11px;">
                  <li>Quantidade de peças estruturais danificadas de 0 a 1 
                    <strong>-> DANO DE PEQUENA MONTA OU SEM DANO</strong>
                  </li>
                  <li>Quantidade de peças estruturais danificadas de 2 a 6 
                    <strong>-> DANO DE MÉDIA MONTA</strong>
                  </li>
                  <li>Quantidade de peças estruturais danificadas maior que 6 
                    <strong>-> DANO DE GRANDE MONTA</strong>
                  </li>
                </ul>

                <!-- Motocicleta -->
                <ul *ngIf="dadosLaudo?.laudo_tipo == 'Motocicleta'" 
                    class="list-unstyled mb-0" style="font-size: 11px;">
                  <li>Quantidade de peças estruturais danificadas igual a 0 
                    <strong>-> DANO DE PEQUENA MONTA OU SEM DANO</strong>
                  </li>
                  <li>Quantidade de peças estruturais danificadas de 1 a 4 
                    <strong>-> DANO DE MÉDIA MONTA</strong>
                  </li>
                  <li>Quantidade de peças estruturais danificadas maior que 4 
                    <strong>-> DANO DE GRANDE MONTA</strong>
                  </li>
                </ul>

                <!-- Caminhão / Cavalo Mecânico / Ônibus -->
                <ul *ngIf="dadosLaudo?.laudo_tipo == 'Caminhão'  || dadosLaudo?.laudo_tipo == 'Ônibus'" 
                    class="list-unstyled mb-0" style="font-size: 11px;">
                  <li>M: Item que individualmente implica em Dano de Média Monta.</li>
                  <li class="mb-2">G: Item que individualmente implica em Dano de Grande Monta.</li>
                  <li>• Dano de Pequena Monta ou Sem Dano: 
                    <strong> quando não houver nenhum item assinalado nas colunas "SIM" ou "N/A"</strong>
                  </li>
                  <li>• Dano de Média Monta (M): 
                    <strong> quando o item de maior gravidade assinalado nas colunas "SIM" ou "N/A" for de categoria M</strong>
                  </li>
                  <li>• Dano de Grande Monta (G): 
                    <strong> quando o item de maior gravidade assinalado nas colunas "SIM" ou "N/A" for de categoria G</strong>
                  </li>
                </ul>


                <!-- Outros -->
                <ul *ngIf="dadosLaudo?.laudo_tipo == 'Outros'" 
                    class="list-unstyled mb-0" style="font-size: 11px;">
                  <li>
                    Classificação conforme procedimento específico do veículo.
                  </li>
                </ul>
              </div>
              <div class="col-3 text-center border-start border-dark py-2">
                <div class="p-2 border border-2 rounded" 
                     [ngClass]="{
                       'border-success text-success': classificacao === 'Pequena Monta',
                       'border-warning text-warning': classificacao === 'Média Monta',
                       'border-danger text-danger': classificacao === 'Grande Monta'
                     }">
                  <h5 class="mb-0 fw-bold">{{ classificacao | uppercase }}</h5>
                </div>
              </div>
            </div>
          </div>
        
          <div class="col-md-12 mt-2 laudo-pmmg">
            <p class="text-center">
              Relatório gerado pelo software SIGA PARTS em {{dataAtual}}<br/>
              <a target="_blank" href="http://www.arcotecnologia.com/">arcotecnologia.com</a>
            </p>
          </div>
          
          <!--
          <div class="row mt-5">
            <div class="col-12 text-center small">
              <div class="d-inline-block border-top border-dark px-5 pt-1">
                Assinatura do Agente / Carimbo
              </div>
            </div>
          </div>-->

        </div> </div>
    </div>
  </div>
</div>